export default "__VITE_ASSET__Cj3D$LIO__"